import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function PaymentReturn() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const isCancel = window.location.pathname.includes("cancel");
  const [status, setStatus] = useState(isCancel ? "cancelled" : "checking");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (isCancel || !sessionId) return;
    if (attempts > 8) { setStatus("timeout"); return; }
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setStatus("failed"); return; }
        setAttempts((a) => a + 1);
      } catch { setAttempts((a) => a + 1); }
    }, 1800);
    return () => clearTimeout(t);
  }, [attempts, sessionId, isCancel]);

  return (
    <div className="min-h-screen bg-[#0B0F17] grain">
      <Navbar />
      <div className="max-w-lg mx-auto px-4 py-20 text-center animate-fade-up">
        <div className="card-surface rounded-2xl p-8 sm:p-12">
          {status === "checking" && (
            <>
              <Loader2 className="h-12 w-12 animate-spin text-[#39FF14] mx-auto mb-6" />
              <h1 className="font-display text-2xl font-bold text-slate-50">Vérification du paiement…</h1>
              <p className="text-slate-400 mt-2">Merci de patienter quelques secondes.</p>
            </>
          )}
          {status === "paid" && (
            <>
              <CheckCircle2 className="h-16 w-16 text-emerald-400 mx-auto mb-6" />
              <h1 className="font-display text-3xl font-bold text-slate-50" data-testid="payment-success-title">Paiement confirmé</h1>
              <p className="text-slate-400 mt-3">Votre course est réservée et payée. Vous recevrez un rappel la veille.</p>
              <Button onClick={() => navigate("/")} className="mt-8 bg-[#39FF14] hover:bg-[#5CFF45] text-[#0B0F17] font-semibold">Retour à l'accueil</Button>
            </>
          )}
          {(status === "cancelled" || status === "failed" || status === "timeout") && (
            <>
              <XCircle className="h-16 w-16 text-slate-500 mx-auto mb-6" />
              <h1 className="font-display text-2xl font-bold text-slate-50">Paiement non finalisé</h1>
              <p className="text-slate-400 mt-3">
                {status === "timeout" ? "Le paiement prend plus de temps que prévu. Vérifiez votre espace client."
                  : "Votre réservation est enregistrée mais non payée. Vous pouvez régler à bord ou réessayer."}
              </p>
              <Button onClick={() => navigate("/")} className="mt-8 bg-[#39FF14] hover:bg-[#5CFF45] text-[#0B0F17] font-semibold">Retour à l'accueil</Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
